import React from "react";
import './Portfolio.css'
import {Swiper, SwiperSlide} from 'swiper/react'
import Sidebar from '../../img/Sidebar.png';
import Ecommerce from '../../img/Ecommerce.PNG';
import HOC from'../../img/hoc.png';
import MusicApp from '../../img/MusicApp.png';
import 'swiper/css'

const portfolio = () => {



    return(
        <div className="Portfolio" id="Portfolio">

         <span >Recent Project</span>
         <span>Portfolio</span>

                {/* Slider */}
         <Swiper 
         spaceBetween={30}
         slidesPerView={3}
         grabCursor={true}
         className='Portfolio-Slider'
         >
          
          <SwiperSlide>
              <img src={Sidebar} alt=""/>
            </SwiperSlide>

            <SwiperSlide>
              <img src={Ecommerce} alt=""/>
            </SwiperSlide>

            <SwiperSlide>
              <img src={HOC} alt=""/>
            </SwiperSlide>

            <SwiperSlide>
              <img src={MusicApp} alt=""/>
            </SwiperSlide>

         </Swiper>
        </div>
    )
}

export default portfolio;
